import {DOCUMENT, ɵparseCookieValue as parseCookieValue} from '@angular/common';
import {Inject, Injectable, InjectionToken, PLATFORM_ID} from '@angular/core';
import {HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpXsrfTokenExtractor} from '@angular/common/http';
import {Observable} from 'rxjs/internal/Observable';

/**
 * `HttpInterceptor` which adds an XSRF token to eligible outgoing requests.
 */
@Injectable()
export class XsrfCorsInterceptor implements HttpInterceptor {
  private lastCookieString = '';
  private lastToken: string|null = null;

  /**
   * @internal for testing
   */
  parseCount = 0;
  private cookieName = 'XSRF-TOKEN';

  constructor(@Inject(DOCUMENT) private doc: any, @Inject(PLATFORM_ID) private platform: string) {
    console.log('XsrfInterceptor ');
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('XsrfInterceptor.intercept');
    const lcUrl = req.url.toLowerCase();
    // Skip both non-mutating requests and absolute URLs.
    // Non-mutating requests don't require a token, and absolute URLs require special handling
    if (req.method === 'GET' || req.method === 'HEAD') {
      return next.handle(req);
    }

    let requestToForward = req;
    const token = this.getToken() as string;
    if (token !== null) {
      requestToForward = req.clone({setHeaders: {'X-XSRF-TOKEN': token}});
    }
    return next.handle(requestToForward);
  }

  getToken(): string|null {
    console.log('getToken cookieName: ' + this.cookieName);
    if (this.platform === 'server') {
      return null;
    }
    const cookieString = this.doc.cookie || '';
    console.log('cookieString ' + cookieString);
    if (cookieString !== this.lastCookieString) {
      this.parseCount++;
      this.lastToken = parseCookieValue(cookieString, this.cookieName);
      this.lastCookieString = cookieString;
    }

    console.log('lastToken ' + this.lastToken);
    return this.lastToken;
  }
}
